import { render } from "./ChildrenList.vue?vue&type=template&id=f4da0ff6"
import script from "./ChildrenList.vue?vue&type=script&lang=js"
export * from "./ChildrenList.vue?vue&type=script&lang=js"

import "./ChildrenList.vue?vue&type=style&index=0&id=f4da0ff6&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__